import { ref } from 'vue'
import { useAlert } from '@/composables/useAlert'
import { apiCriticasIntrajornada } from '@/services/criticasIntrajornada'
import { defineStore } from 'pinia'

export const useCriticasIntrajornada = defineStore('criticasIntrajornada', () => {
  const { obter, post } = apiCriticasIntrajornada()
  const { alertWarn } = useAlert()

  const criticasIntrajornada = ref()
  const loadingCriticasIntrajornada = ref(false)

  const sucessoRelatorio = ref(false)

  const exportarCriticasIntrajornadaCsv = async (params) => {
    try {
      await post(params)
      sucessoRelatorio.value = true
    } catch (error) {
      return alertWarn('Nenhum registro encontrado!')
    } finally {
      setTimeout(() => (sucessoRelatorio.value = false), 1000)
    }
  }

  const obterCriticasIntrajornada = async (params) => {
    try {
      loadingCriticasIntrajornada.value = true
      const resposta = await obter(params)
      criticasIntrajornada.value = resposta
    } catch (error) {
      criticasIntrajornada.value = null
    } finally {
      loadingCriticasIntrajornada.value = false
    }
  }

  return {
    criticasIntrajornada,
    loadingCriticasIntrajornada,
    obterCriticasIntrajornada,
    exportarCriticasIntrajornadaCsv,
    sucessoRelatorio
  }
})
